import { IStairConfig, IStepGeometry, IStringerGeometry } from '@stair-craft/common/util';

import { buildTurnSupports } from '../shared-build-turn-supports/build-turn-supports';
import {
    applyWinderRiserOutlines,
    landingSupports,
    turnSupportOptions,
    winderSupportSteps,
} from '../shared-build-turn-supports/turn-support-steps';
import { IPlanPoint } from '../shared-plan-geometry/plan-geometry';

/**
 * Boards of an L turn: under the landing's two outer edges (the side wall, then the far edge up
 * to flight 2), or under every winder along the outer wall. The L turn's inner corner stays
 * open. Winder risers are cut where the outer board takes over.
 */
export function buildLShapeTurnSupports(
    config: IStairConfig,
    turnSteps: IStepGeometry[],
    riserHeight: number,
    treadDepth: number,
    turnStartZ: number,
    entryBottom?: number
): IStringerGeometry[] {
    const options: ReturnType<typeof turnSupportOptions> = turnSupportOptions(config, riserHeight, treadDepth, entryBottom);
    if (config.turnType === 'winder') {
        applyWinderRiserOutlines(turnSteps, false, config);
        return buildTurnSupports(winderSupportSteps(turnSteps, false), options);
    }
    const landing: IStepGeometry | undefined = turnSteps.at(0);
    if (!landing) {
        return [];
    }
    const sw: number = config.stairWidth;
    const farZ: number = turnStartZ + sw;
    const isRight: boolean = config.turnDirection === 'right';
    const outerX: number = isRight ? 0 : sw;
    const innerX: number = isRight ? sw : 0;
    const wall: IPlanPoint[] = [
        { x: outerX, z: turnStartZ },
        { x: outerX, z: farZ },
        { x: innerX, z: farZ },
    ];
    return landingSupports(
        landing,
        wall,
        [
            { x: innerX, z: turnStartZ },
            { x: innerX, z: farZ },
        ],
        options
    );
}
